<template lang="pug">
.warning-wall(:class="{ embed }"): main: .container.page-wrapper
    .page
        form.body(@submit.prevent="submit" novalidate)
            .content(v-if="warning")
                .message(v-html="warning" data-testid="warning-wall-message")

            .hcp-id(v-if="hcpIdVerification" data-testid="hcp-id-field")
                base-input(
                    v-model="hcpIdNumber"
                    name="hcp-id-number"
                    type="text"
                    autocomplete="off"
                    :label="$t(hcpIdLabelKey)"
                    :errors="hcpIdErrors")

            .actions
                button.btn.btn-primary.btn-medium.important(type="submit" data-testid="warning-wall-submit" :class="{'embed-btn': embed}") {{ submitLabel }}
                a.btn.btn-medium.important(v-if="rejectHref" :href="rejectHref" :target="embed ? '_top' : null" rel="noopener noreferrer" data-testid="warning-wall-reject" :class="{'embed-btn': embed}") {{ $t('registration.actions.warning_wall_reject') }}
</template>
<script>
// Utils
import { get, isEmpty } from 'lodash';
import { getHcpIdVerificationConfig, verifyHcpId, HCP_ID_STATUS } from '@/libs/hcp-id';
import { saveHcpIdVerification } from '@/libs/hcp-id/storage';

// Components
import BaseInput from '@/components/form-elements/BaseInput.vue';

export default {
    name: 'WarningWall',

    components: { BaseInput },

    props: {
        config: {
            type: Object,
            required: true
        },

        embed: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        const event = this.config.event_details || {};
        const defaultLocale = event.languages?.[0] || 'en';
        const wallConfig = event.warning_wall_config || {};
        const defaultWarning = get(wallConfig, `content.${defaultLocale}`, '');
        const defaultRejectHref = get(wallConfig, `redirect.${defaultLocale}`, '');

        return {
            wallConfig,
            defaultLocale,
            defaultWarning,
            defaultRejectHref,
            hcpIdVerification: getHcpIdVerificationConfig(this.config),
            hcpIdNumber: '',
            hcpIdInvalid: false
        }
    },

    computed: {
        warning() {
            let message = get(this.wallConfig, `content.${this.$i18n.locale}`);
            if (isEmpty(message)) {
                message = this.defaultWarning;
            }
            return message;
        },

        rejectHref() {
            let href = get(this.wallConfig, `redirect.${this.$i18n.locale}`);
            if (isEmpty(href)) {
                href = this.defaultRejectHref;
            }
            return href;
        },

        /** @returns {string} */
        storagePrefix() {
            const { branding, id } = this.$route.params;
            return `${branding}_${id}`;
        },

        /** @returns {string} */
        hcpIdLabelKey() {
            return `registration.hcp_id.label_${this.hcpIdVerification.rules.code.toLowerCase()}`;
        },

        /** @returns {string[]} */
        hcpIdErrors() {
            return this.hcpIdInvalid ? [this.$t('registration.hcp_id.invalid')] : [];
        },

        /** @returns {string} */
        submitLabel() {
            return this.hcpIdVerification
                ? this.$t('registration.actions.hcp_id_verify')
                : this.$t('registration.actions.warning_wall_accept');
        }
    },

    watch: {
        hcpIdNumber() {
            this.hcpIdInvalid = false;
        }
    },

    methods: {
        submit() {
            if (this.hcpIdVerification) {
                this.verify();
            } else {
                this.accept();
            }
        },

        verify() {
            const { rules } = this.hcpIdVerification;
            const { status, number } = verifyHcpId(this.hcpIdNumber, rules);
            if (status !== HCP_ID_STATUS.VALID) {
                this.hcpIdInvalid = true;
                return;
            }

            saveHcpIdVerification(this.$services.storage, this.storagePrefix, { country: rules.code, number });
            this.accept();
        },

        accept() {
            this.$services.storage.setItemWithPrefix(this.storagePrefix, 'warning_wall_ack', 1);
            this.$emit('accepted');
        }
    }
};
</script>
